import { createContext, useState, ReactNode } from "react";

export interface AudioContextType {
  isMuted: boolean;
  setIsMuted: (muted: boolean) => void;
  toggleMute: () => void;
}

const AudioContext = createContext<AudioContextType | undefined>(undefined);

export { AudioContext };

export function AudioProvider({ children }: { children: ReactNode }) {
  const [isMuted, setIsMuted] = useState(true); // Start muted by default

  const toggleMute = () => setIsMuted((prev) => !prev);

  return (
    <AudioContext.Provider value={{ isMuted, setIsMuted, toggleMute }}>
      {children}
    </AudioContext.Provider>
  );
}
